/**
 * The words of the Confidentiality Roles screens (piece 13; piece 15; T2352):
 * Settings › People › Confidentiality Roles and the Person page's tile, spread
 * into the one string lookup.
 */
export const CONFIDENTIALITY_STRINGS = {
  'settings.confidentialityRoles.title': 'Confidentiality Roles',
  'settings.confidentialityRoles.hint': 'A role opens the files marked with it to the people who hold it and a current personal NDA. Grant it from a Person page.',
  'settings.confidentialityRoles.add': '+ Add Role',
  'settings.confidentialityRoles.addTitle': 'Add Role',
  'settings.confidentialityRoles.name': 'Name',
  'settings.confidentialityRoles.description': 'Description',
  'settings.confidentialityRoles.noDescription': 'No description',
  'settings.confidentialityRoles.inactive': 'Inactive',
  'settings.confidentialityRoles.held': 'Held by {count}',
  'settings.confidentialityRoles.none': 'No confidentiality role yet. Add the first with + Add Role.',
  'confidentiality.tile.none': 'None yet',
  'confidentiality.tile.agreement': 'NDA from {from}',
  'confidentiality.tile.agreementUntil': 'NDA {from} to {until}',
  'confidentiality.tile.grantedBy': 'Granted by {name}',
  'confidentiality.tile.since': 'Since {from}',
  'confidentiality.tile.span': '{from} to {until}',
  'confidentiality.tile.end': 'End',
  'confidentiality.tile.endTitle': 'End Grant',
  'confidentiality.tile.endConsequence': 'The person stops opening the files marked with this role. The grant stays on the tile as history.',
  'confidentiality.window.title': 'Grant Role',
  'confidentiality.window.subtitle': 'A grant is backed by the person’s own NDA.',
  'confidentiality.window.role': 'Role',
  'confidentiality.window.agreement': 'NDA Agreement',
  'confidentiality.window.noAgreement': 'No agreement',
  'confidentiality.window.noAgreements': 'This person holds no personal NDA yet. Upload one from a Company page’s Access & Agreements tile, naming this person.',
  'confidentiality.window.noRoles': 'Every active role is already granted to this person, or none exists yet.',
  'confidentiality.window.pickRole': 'Pick a role first.',
  'confidentiality.window.act': 'Grant Role',
  'confidentiality.window.needsAdmin': 'Granting a role needs the administrative capability, which this login does not hold.',
  'confidentiality.state.active': 'Active',
  'confidentiality.state.upcoming': 'Upcoming',
  'confidentiality.state.draft': 'Draft',
  'confidentiality.state.demanded': 'Demanded',
  'confidentiality.state.expired': 'Expired',
  'confidentiality.state.revoked': 'Revoked',
  'confidentiality.state.ended': 'Ended',
} as const;
